import { IResource } from '@/contexts/backoffice/library/models/resource'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getResourcecategoriesOptions } from '../../../../../redux/actions/resourcecategories'
import { IRootState } from '../../../../../redux/types'
import { IVisibility } from '@/contexts/backoffice/courses/models/course'
import { useTranslation } from 'react-i18next'

function useCreateMediaState() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { globalCountriesId, globalLanguageId } = useSelector((state: IRootState) => state.global)
  const [resource, setResource] = useState<IResource>({
    fileNames: [],
    resourcetypes: [],
    brand: null,
    line: null,
    countries: [],
    languages: [],
    role: null,
    visibility: null,
    categories: []
  })

  const VISIBILITY: IVisibility[] = [
    { id: 0, name: t('private') },
    { id: 1, name: 'VIP' },
    { id: 2, name: t('public') }
  ]

  const handleInputChange = (inputName: string, value: any) => {
    if (inputName === 'brand') {
      setResource({ ...resource, brand: value })
      if (value !== null) {
        dispatch(
          getResourcecategoriesOptions({
            languageId: globalLanguageId,
            countriesId: globalCountriesId,
            familyId: null,
            brandId: value
          })
        )
      }
    } else {
      setResource({ ...resource, [inputName]: value })
    }
  }

  return { resource, handleInputChange, VISIBILITY }
}

export default useCreateMediaState
